import { isCpfOrCnpj, isPhone } from "services/utils/regexForValidations"
import _ from "lodash"

export const validate = (values, maxNumbers) => {
  const isPortability = values.typeOf === "Portabilidade"
  const errors = {}

  if (!values.assigneeName) {
    errors.assigneeName = "*Nome completo precisa ser preenchido"
  } else if (values.assigneeName.trim().length < 3) {
    errors.assigneeName = "*Nome completo precisa de no mínimo 3 caracteres"
  } else if (values.assigneeName.length > 50) {
    errors.assigneeName = "*Nome completo pode ter no máximo 50 caracteres"
  }

  if (!values.assigneeDoc) {
    errors.assigneeDoc = "*Preencher com documento CPF ou CNPJ."
  } else if (!isCpfOrCnpj(values.assigneeDoc)) {
    errors.assigneeDoc = "*CPF ou CNPJ inválido."
  }

  if (!values.uf) {
    errors.uf = "*UF precisa ser preenchido"
  }

  if (!values.areaLocal) {
    errors.areaLocal = "*Área local precisa ser preenchida"
  }

  if (!values.locality) {
    errors.locality = "*Localidade precisa ser preenchida"
  }

  if (isPortability) {
    values.phonesPortability.forEach((element, index) => {
      if (!isPhone(element.phone)) {
        errors[`phonesPortability[${index}].phone`] =
          "*Telefone com formato incorreto"
      }
    })
  }

  if (isPortability && values.phonesPortability.length > 0) {
    const phoneCount = _.countBy(values.phonesPortability, "phone")
    const duplicates = _.keys(_.pickBy(phoneCount, (count) => count > 1))

    if (duplicates.length > 0) {
      const lastDuplicatePhone = duplicates[duplicates.length - 1]
      const index = _.findLastIndex(values.phonesPortability, {
        phone: lastDuplicatePhone
      })
      errors[`phonesPortability[${index}].phone`] = "*Telefone já adicionado"
    }
  }

  if (values.qnt > maxNumbers) {
    errors.qnt = "*Limite de números ultrapassado"
  }

  if (values.qnt && values.qnt < 1) {
    errors.qnt = "*Quantidade incorreta de números"
  }

  return errors
}

export const INITIAL_VALUES = {
  typeOf: "",
  assigneeName: "",
  assigneeDoc: "",
  uf: "",
  areaLocal: "",
  locality: "",
  qnt: 1,
  phonesPortability: [{ phone: "" }]
}

export const FIELDS_TO_VALIDATE = {
  typeOfSale: ["typeOf"],
  customerInfo: ["assigneeName", "assigneeDoc", "locality"],
  amountOfNumbers: ["qnt"]
}

export const INITIAL_STATE_FORM = {
  typeOfSale: {
    id: "typeOfSale",
    title: "Tipo de Venda",
    icon: "1",
    isEditing: true,
    isCompleted: false
  },
  customerInfo: {
    id: "customerInfo",
    title: "Dados do Cliente Final",
    icon: "2",
    isEditing: false,
    isCompleted: false
  },
  amountOfNumbers: {
    id: "amountOfNumbers",
    title: "Quantidade de números",
    title2: "Número do cliente a ser portado",
    icon: "3",
    isEditing: false,
    isCompleted: false
  }
}

export const TYPE_OF_SALE = {
  PORTABILITY: {
    TITLE: "Portabilidade",
    DESC: "portabilidade",
    ACTION: "CREATE_PARTNER_ORDER_PORT"
  },
  NEW_SALE: {
    TITLE: "Nova venda",
    DESC: "venda",
    ACTION: "CREATE_PARTNER_ORDER_ALGAR"
  }
}

export const ERRORS_FIXED_VOICE = {
  LOCALITIES: {
    title: "Erro ao buscar localidades!",
    message: "Erro ao tentar buscar ufs, áreas locais ou localidades"
  },
  SALE_PORTABILITY: {
    title: "Erro ao concluir pedido",
    message:
      "Ao tentar concluir pedido, ocorreu um erro. Por gentileza tente mais tarde!"
  },
  INVALID_NUMBER: {
    title: "Erro! Telefone inválido",
    message:
      "O Telefone NUMBER não está válido para iniciar um processo de portabilidade, favor verificar!"
  }
}



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/NewSale/constants.js